<template>
  <div>
    <v-layout class="mb-3" xs12 md12 lg12 row wrap align-center>
      <v-flex xs12 md6 lg6 class="pr-3">
        <v-select
          hide-details
          content-class="whatsapp-select-category"
          v-model="selectedCategory"
          :items="categoryOptions"
          label="Filtrar por Categoria"
          clearable
          prepend-inner-icon="mdi-filter"
          @change="getInitiatives()"
        ></v-select>
      </v-flex>
      <v-flex xs12 md6 lg6 class="pr-3">
        <sender-selector
          :items="senders"
          :box="false"
          v-model="selectedSender"
          return-object
          @input="getInitiatives()"
        ></sender-selector>
      </v-flex>
    </v-layout>
    <v-layout row wrap align-center>
      <v-flex xs12 md12 lg12>
        <v-autocomplete
          class="whatsapp-initiative-selector"
          @change="(ev) => (initiative = ev)"
          :value="initiative"
          :items="filteredInitiatives"
          :search-input.sync="searchInitiatives"
          item-text="fullText"
          item-value="id"
          height="60"
          hint="★ Indica uma iniciativa exclusiva para esse credor"
          label="Iniciativa do WhatsApp"
          content-class="whatsapp-autocomplete-content"
          persistent-hint
          clearable>
          <!-- Slot para item selecionado -->
          <template v-slot:selection="{ item }">
            <div style="width: 100%; padding: 6px 0" class="selected-initiative">
              <p>
                <template>
                  <v-tooltip v-if="item.name.length > 30" bottom>
                    <template v-slot:activator="{ on }">
                      <span>
                        <span v-on="on" class="font-weight-bold">{{
                          item.name | truncate(30)
                        }}</span>
                        [ <i>{{ item.key }}</i> ]
                      </span>
                    </template>
                    <p>{{ item.name }}</p>
                  </v-tooltip>

                  <span v-else>
                    <span class="font-weight-bold">{{ item.name }}</span> [ <i>{{ item.key }}</i> ]
                  </span>
                </template>

                <span
                  :class="[item.meta_status]"
                  class="initiative_selector_initiative--status mr-1"
                  v-if="item.meta_status"
                >
                  {{ item.meta_status | whatsappTemplateStatus }}
                </span>

                <QualityChip
                  v-if="item.meta_status == 'APPROVED' && item.meta_quality_score"
                  :quality="item.meta_quality_score"
                ></QualityChip>

                <span class="ml-2" v-if="item.creditor_id"> ★ </span>

                <v-chip class="py-0 my-0" small dense outline>
                  <span v-if="item.meta_category === 'MARKETING'">Marketing</span>
                  <span v-else-if="item.meta_category === 'UTILITY'">Utilidade</span>
                  <span v-else-if="item.meta_category === 'AUTHENTICATION'">Autenticação</span>
                  <span v-else>{{ item.meta_category }}</span>
                </v-chip>

                <ApprovalIcon
                  :approved="item.approved"
                  :approvedBy="item.approved_by"
                  :approvedAt="item.approved_at"
                ></ApprovalIcon>
              </p>

              <p>
                <span v-if="item.sender">
                  <i>#{{ item.sender.id }}</i> {{ item.sender.phone_number | phoneNumber }}
                </span>

                <span
                  v-if="item.sender && item.sender.meta_quality_rating_v2"
                  class="initiative_selector_sender--status"
                  :class="[item.sender.meta_quality_rating_v2]">
                  {{ item.sender.meta_quality_rating_v2 | whatsappSenderQuality }}
                </span>

                <FlaggedIcon
                  v-if="
                    item.sender.meta_status &&
                    item.sender.meta_status === 'FLAGGED'
                  "
                ></FlaggedIcon>

              </p>
            </div>
          </template>

          <!-- Slot para cada item da lista -->
          <template v-slot:item="{ item }">
            <v-list-tile-content class="initiative-items">
              <p class="d-flex flex-row align-center">
                <span v-if="item.name.length > 30">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <span class="font-weight-bold">{{ item.name | truncate(30) }}</span> [
                        <i>{{ item.key }}</i> ]
                      </span>
                    </template>
                    <span>{{ item.name }}</span>
                  </v-tooltip>
                </span>
                <span v-else>
                  <span class="font-weight-bold">{{ item.name }}</span> [ <i>{{ item.key }}</i> ]
                </span>

                <span
                  class="initiative_selector_initiative--status mx-1"
                  :class="[item.meta_status]"
                  v-if="item.meta_status"
                >
                  {{ item.meta_status | whatsappTemplateStatus }}
                </span>

                <QualityChip
                  v-if="item.meta_status == 'APPROVED' && item.meta_quality_score"
                  :quality="item.meta_quality_score"
                ></QualityChip>

                <span class="ml-2" v-if="item.creditor_id"> ★ </span>

                <v-chip small outline>
                  <span v-if="item.meta_category === 'MARKETING'">Marketing</span>
                  <span v-else-if="item.meta_category === 'UTILITY'">Utilidade</span>
                  <span v-else-if="item.meta_category === 'AUTHENTICATION'">Autenticação</span>
                  <span v-else>{{ item.meta_category }}</span>
                </v-chip>

                <ApprovalIcon
                  :approved="item.approved"
                  :approvedBy="item.approved_by"
                  :approvedAt="item.approved_at"
                ></ApprovalIcon>
              </p>

              <p class="d-flex align-center">
                <span v-if="item.sender" class="sender-name mr-1">
                  <i># {{ item.sender.id }}</i> {{ item.sender.phone_number | phoneNumber }}
                </span>

                <QualityChip
                  v-if="
                    item.sender &&
                    item.sender.meta_quality_rating_v2
                  "
                  :quality="item.sender.meta_quality_rating_v2"
                  tooltip="Qualidade do Sender"
                  size="small"
                ></QualityChip>

                <FlaggedIcon
                  v-if="
                    item.sender.meta_status &&
                    item.sender.meta_status === 'FLAGGED'
                  "
                ></FlaggedIcon>
              </p>
            </v-list-tile-content>
          </template>

          <!-- Botão extra -->
          <template v-slot:append-outer>
            <v-btn
              small
              icon
              target="_blank"
              title="Editar iniciativas"
              :to="selectedInitiativeUrl">
              <v-icon small>edit</v-icon>
            </v-btn>
          </template>
        </v-autocomplete>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WhatsAppService from "@/services/whatsapp";
import senderSelector from "./senderSelector.vue";
import ApprovalIcon from "@/components/ui/ApprovalIcon.vue";
import FlaggedIcon from "@/components/ui/FlaggedIcon.vue";
import QualityChip from "@/components/ui/QualityChip.vue";

export default {
  props: ["creditor_id", "value", "scope"],
  components: {
    ApprovalIcon,
    QualityChip,
    FlaggedIcon,
    senderSelector,
  },
  data: () => {
    return {
      searchInitiatives: "",
      initiative: null,
      selectedCategory: null,
      selectedSender: null,
      senders: [],
      loadingSenders: false,
    };
  },

  async created() {
    this.searchInitiatives = "";
    this.selectedCategory = null;
    this.selectedSender = null;

    await this.getSenders();
    await this.getInitiatives();
  },

  computed: {
    ...mapGetters("initiativeManager", ["initiativesList"]),

    categoryOptions() {
      return [
        { text: "Marketing", value: "MARKETING" },
        { text: "Utilidade", value: "UTILITY" },
        { text: "Autenticação", value: "AUTHENTICATION" },
      ];
    },
    selectedInitiativeUrl() {
      if (!this.initiative) return "/initiatives";

      const initiative = Array.isArray(this.initiativesList)
        ? this.initiativesList.find((i) => i.id === this.initiative)
        : null;

      return `/initiatives${
        initiative && initiative.key ? `?q=${initiative.key}` : ""
      }`;
    },
    filteredInitiatives() {
      if (this.initiativesList) {
        let initiatives = this.initiativesList;

        if (this.searchInitiatives) {
          const term = this.searchInitiatives.toLowerCase();
          initiatives = initiatives.filter(
            (i) =>
              (i.name && i.name.toLowerCase().includes(term)) ||
              (i.key && i.key.toLowerCase().includes(term)) ||
              (i.sender &&
                i.sender.phone_number &&
                i.sender.phone_number.toLowerCase().includes(term)) ||
              (i.sender && i.sender.id && `#${String(i.sender.id)}`.toLowerCase().includes(term))
          );
        }

        initiatives.sort((a, b) => {
          return a.created_at - b.created_at;
        });

        initiatives.forEach((i) => {
          i.fullText = `${i.name} - ${i.key}`;
          if (i.sender) {
            i.fullText += ` (#${i.sender.id} ${i.sender.phone_number})`;
          }
        });

        return initiatives;
      }
      return [];
    },
  },
  methods: {
    ...mapActions("initiativeManager", {
      getAllInitiatives: "getAllInitiatives",
    }),

    async getInitiatives() {
      const params = this.buildParams();
      await this.getAllInitiatives(params);
    },

    getSenders() {
      if (this.loadingSenders) return;

      this.loadingSenders = true;
      WhatsAppService.getSenders()
        .then((response) => {
          this.senders = [];
          response.objects.forEach((obj) => {
            this.senders.push(obj);
          });
          this.senders.sort((a, b) => {
            if (a.phone_number < b.phone_number) return -1;
            if (a.phone_number > b.phone_number) return 1;
            return 0;
          });
        })
        .catch((e) => {
          console.error("Não foi possível buscar os remetentes do WhatsApp", e);
          this.$store.commit("showSnackbar", "Não foi possível buscar os remetentes do WhatsApp");
        })
        .finally(() => {
          this.loadingSenders = false;
        });
    },

    buildParams() {
      const params = {
        limit: 9999,
        active: true,
        empty_creditor: true,
        meta_status: 'APPROVED'    
      };

      if (this.$props.creditor_id) params.creditor = this.$props.creditor_id;
      if (this.selectedCategory) params.meta_category = this.selectedCategory;
      if (this.selectedSender) params.phone_sender_id = this.selectedSender.id;
      if (this.$props.scope) {
        params.scope = this.$props.scope
        params.empty_scope = true
      };

      return params;
    },
  },
  watch: {
    value(newVal) {
      this.selectedCategory = null;
      this.selectedSender = null;
      this.initiative = newVal;
    },
    initiative(newVal) {
      this.$emit("input", newVal);
    },
  },
};
</script>

<style lang="scss" scoped>
.whatsapp-initiative-selector {
  display: flex;
  align-items: center;
  .initiative-items,
  .selected-initiative {
    font-size: 13px !important;
    i {
      color: grey;
    }
  }
}

.initiative_selector_initiative--status {
  border: 1px solid;
  border-radius: 2px;
  font-weight: 500;
  padding: 1px 2px;
  white-space: nowrap;
  font-size: 12px;

  &.APPROVED {
    background-color: #ebf5f1;
    border-color: #b6d1c6;
    color: #247058;
  }

  &.APPROVED.LOW {
    background-color: #fff0f1;
    border-color: #facfd4;
    color: #ab1628;
  }

  &.APPROVED.MEDIUM {
    background-color: #fff8e3;
    border-color: #ffe299;
    color: #ad7410;
  }

  &.DISABLED,
  &.UNKNOWN {
    background-color: #e5e5e3;
    border-color: #a6a5a2;
    color: #545452;
  }

  &.PAUSED,
  &.FIRST_PAUSED,
  &.SECOND_PAUSED {
    background-color: #fff8e3;
    border-color: #ffe299;
    color: #ad7410;
  }

  &.PENDING_DELETION,
  &.REJECTED {
    background-color: #fff0f1;
    border-color: #facfd4;
    color: #ab1628;
  }
}

.quality {
  text-transform: lowercase;
}

.whatsapp-autocomplete-content .v-list__tile {
  height: 64px !important;
  min-height: 64px !important;
  border-bottom: 1px solid lightgray;
  i {
    color: grey !important;
  }
}

.whatsapp-autocomplete-content .v-list__tile__content {
  height: 64px !important;
  min-height: 64px !important;
  i {
    color: grey !important;
  }
}

.whatsapp-select-category .v-select__slot {
  height: 64px !important;
  min-height: 64px !important;
}

.whatsapp-select-category .v-select__selections {
  height: 64px !important;
  min-height: 64px !important;
}
</style>